import _concat from "lodash/concat";

import homeRoutes from "./views/home/routes";

export default _concat(
  homeRoutes,
);
